import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { useTrackedMutation as useMutation } from '@ais-ui/performance-tracking';
import {
  scheduleReport,
  ScheduleResponse,
  updateReportTemplateAndReport,
} from './scheduleReports';
import { ReportBackendTypes } from './createReports';

interface scheduleReportInput {
  type: ReportBackendTypes;
  reportParams: string;
  templateId: string;
  name: string;
  interval: string;
  intervalStart: number;
  endTime: string;
}

export const useScheduleReport = (): UseMutationResult<
  ScheduleResponse,
  Error,
  scheduleReportInput,
  unknown
> => {
  const { dbSession } = useSession();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      args: scheduleReportInput
    ): Promise<ScheduleResponse> => {
      if (!dbSession) {
        throw new Error('dbSession is not defined.');
      }

      const {
        type,
        reportParams,
        templateId,
        name,
        interval,
        intervalStart,
        endTime,
      } = args;

      await updateReportTemplateAndReport(dbSession, type, reportParams);

      return scheduleReport(
        dbSession,
        templateId,
        name,
        interval,
        intervalStart,
        endTime
      );
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['getReportTemplates'] }),
  }, 'report:schedule');
};
